import type { ReactElement } from 'react';
import type { PinMessageIconType } from '@fdh/shared';

export const PIN_MESSAGE_ICON_OPTIONS: PinMessageIconType[] = ['info', 'remind', 'special_alert'];

export type PinMessageIconTheme = {
  badge: string;
  border: string;
  text: string;
};

export const pinMessageIconTheme = (iconType: PinMessageIconType): PinMessageIconTheme => {
  if (iconType === 'remind') {
    return {
      badge: 'bg-amber-100 text-amber-700 dark:bg-amber-900/50 dark:text-amber-200',
      border: 'border-amber-200 dark:border-amber-700/60',
      text: 'text-amber-800 dark:text-amber-200',
    };
  }
  if (iconType === 'special_alert') {
    return {
      badge: 'bg-rose-100 text-rose-700 dark:bg-rose-900/50 dark:text-rose-200',
      border: 'border-rose-200 dark:border-rose-700/60',
      text: 'text-rose-800 dark:text-rose-200',
    };
  }
  return {
    badge: 'bg-blue-100 text-blue-700 dark:bg-blue-900/50 dark:text-blue-200',
    border: 'border-blue-200 dark:border-blue-700/60',
    text: 'text-blue-800 dark:text-blue-200',
  };
};

export const pinMessageIconSvg = (iconType: PinMessageIconType, className = 'h-4 w-4'): ReactElement => {
  if (iconType === 'remind') {
    return (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M15 17h5l-1.4-1.4A2 2 0 0118 14.2V11a6 6 0 10-12 0v3.2a2 2 0 01-.6 1.4L4 17h5m6 0a3 3 0 01-6 0"
        />
      </svg>
    );
  }
  if (iconType === 'special_alert') {
    return (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 3l7 3v6c0 5-3.2 8-7 9-3.8-1-7-4-7-9V6l7-3zm0 5v4m0 4h.01"
        />
      </svg>
    );
  }
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 3a9 9 0 109 9 9 9 0 00-9-9zm0 6h.01M11 11h1v6h1"
      />
    </svg>
  );
};

export const pinMessageIconLabelKey = (iconType: PinMessageIconType): string => {
  if (iconType === 'remind') return 'pinMessage.icon.remind';
  if (iconType === 'special_alert') return 'pinMessage.icon.specialAlert';
  return 'pinMessage.icon.info';
};
